import React from 'react';

const TopBar = () => {
  return (
    <div className="top-utility-bar bg-dark text-light py-2 border-bottom border-secondary border-opacity-25">
      <div className="container">
        {/* Desktop Layout: strictly 1 single row, perfectly aligned across screen */}
        <div className="d-none d-lg-flex align-items-center justify-content-between w-100">
          {/* Left: Contact Details */}
          <div className="d-flex align-items-center gap-3">
            <a
              href="tel:+918108765006"
              className="text-light text-decoration-none d-inline-flex align-items-center hover-accent text-nowrap"
            >
              <i className="fas fa-phone-alt text-primary me-1.5"></i>
              <span>+91 8108765006</span>
            </a>
            <span className="text-secondary opacity-40">|</span>
            <a
              href="tel:+919819214375"
              className="text-light text-decoration-none d-inline-flex align-items-center hover-accent text-nowrap"
            >
              <i className="fas fa-phone-alt text-primary me-1.5"></i>
              <span>+91 9819214375</span>
            </a>
            <span className="text-secondary opacity-40">|</span>
            <a
              href="mailto:abengworks@yahoo.in"
              className="text-light text-decoration-none d-inline-flex align-items-center hover-accent text-nowrap"
            >
              <i className="fas fa-envelope text-primary me-1.5"></i>
              <span>abengworks@yahoo.in</span>
            </a>
          </div>

          {/* Right: Location & Working Hours */}
          <div className="d-flex align-items-center gap-3 text-white-50">
            <a
              href="#location"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center hover-accent text-nowrap"
              title="View Workshop Location & Directions"
            >
              <i className="fas fa-map-marker-alt text-danger me-1.5"></i>
              <span>Santacruz East, Mumbai</span>
            </a>
            <span className="text-secondary opacity-40">|</span>
            <span className="d-inline-flex align-items-center text-nowrap">
              <i className="fas fa-clock text-warning me-1.5"></i>
              <span>Mon - Sat: 9:00 AM - 6:00 PM</span>
            </span>
          </div>
        </div>

        {/* Mobile Layout (< lg): Centered, elegant stacking with guaranteed zero horizontal overflow */}
        <div className="d-flex d-lg-none flex-column align-items-center justify-content-center text-center gap-1 w-100 py-1" style={{ fontSize: '0.72rem' }}>
          {/* Row 1: Direct Phone Call Numbers */}
          <div className="d-flex align-items-center justify-content-center gap-2">
            <a
              href="tel:+918108765006"
              className="text-light text-decoration-none d-inline-flex align-items-center text-nowrap"
            >
              <i className="fas fa-phone-alt text-primary me-1"></i>
              <span>+91 8108765006</span>
            </a>
            <span className="text-secondary opacity-40">|</span>
            <a
              href="tel:+919819214375"
              className="text-light text-decoration-none d-inline-flex align-items-center text-nowrap"
            >
              <i className="fas fa-phone-alt text-primary me-1"></i>
              <span>+91 9819214375</span>
            </a>
          </div>

          {/* Row 2: Official Email */}
          <div>
            <a
              href="mailto:abengworks@yahoo.in"
              className="text-light text-decoration-none d-inline-flex align-items-center text-nowrap"
            >
              <i className="fas fa-envelope text-primary me-1"></i>
              <span>abengworks@yahoo.in</span>
            </a>
          </div>

          {/* Row 3: Location & Working Hours */}
          <div className="d-flex flex-wrap align-items-center justify-content-center gap-1.5 text-white-50 pt-0.5" style={{ fontSize: '0.67rem' }}>
            <a
              href="#location"
              className="text-white-50 text-decoration-none d-inline-flex align-items-center text-nowrap"
            >
              <i className="fas fa-map-marker-alt text-danger me-1"></i>
              <span>Santacruz East, Mumbai</span>
            </a>
            <span className="text-secondary opacity-40">•</span>
            <span className="d-inline-flex align-items-center text-nowrap">
              <i className="fas fa-clock text-warning me-1"></i>
              <span>Mon-Sat: 9 AM - 6 PM</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
